module.exports = __webpack_public_path__ + "img/idcard_front.3695ca8a.png";